import { useState, useEffect } from "react";

import countriesList from "countrycitystatejson";
import iconComponents from "../assets/img/iconComponents";

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

export const useCountries = () => {
  const [countriesStateList, setCountriesStateList] = useState([]);

  useEffect(() => {
    const handleGetCountries = () => {
      const countries = countriesList?.getCountries() || [];
      return countries.map((country) => {
        const Component =
          iconComponents.flags[`${capitalize(country.shortName)}FlagIcon`] ||
          function () {
            return <span>{country.emoji}</span>;
          };
        return {
          ...country,
          flag: <Component className="h-4 w-[22px] max-w-[23px]" />,
        };
      });
    };

    setCountriesStateList(handleGetCountries());
  }, []);

  return [countriesStateList];
};

export const useCountryStates = (country) => {
  const [statesList, setStatesList] = useState([]);
  const handleGetStates = (country) => {
    if (!country) return [];
    const states = countriesList?.getStatesByShort(country) || [];
    return states;
  };

  useEffect(() => {
    setStatesList(handleGetStates(country));
  }, [country]);

  return [statesList];
};
